import { buildInstalledBasePathname, buildInstalledBaseSearch } from './installedBaseUrl';
import { getPathNodesAbove, InstalledBaseNodeWithPath } from './installedBasePath';

export interface NodeShortcutNode extends InstalledBaseNodeWithPath {
    assetLocation?: { id?: string | null } | null;
    system?: { id?: string | null } | null;
}

export interface NodeShortcutTarget {
    pathname: string;
    search: string;
}

// Dedicated detail view of an ASSET or SYSTEM node; undefined for every other
// node type and for ASSET/SYSTEM nodes whose relation is missing (the schema
// allows null).
export const getNodeDetailRoute = (
    node: Pick<NodeShortcutNode, 'nodeType' | 'assetLocation' | 'system'>,
): string | undefined => {
    if (node.nodeType?.key === 'ASSET' && node.assetLocation?.id) {
        return `/assets/${node.assetLocation.id}/details`;
    }
    if (node.nodeType?.key === 'SYSTEM' && node.system?.id) {
        return `/systems/${node.system.id}/details`;
    }
    return undefined;
};

// Click-through convention for node favorites/deep links: ASSET and SYSTEM
// nodes open their dedicated detail views; every other node type opens the
// Installed Base tree with the detail panel on the node.
export const getNodeShortcutTarget = (node: NodeShortcutNode): NodeShortcutTarget => {
    const detailRoute = getNodeDetailRoute(node);
    if (detailRoute) {
        return { pathname: detailRoute, search: '' };
    }
    const ancestorIds = getPathNodesAbove(node)
        .map((n) => n.id)
        .filter((id): id is string => !!id);
    return {
        pathname: buildInstalledBasePathname([null, ...ancestorIds, node.id ?? null]),
        search: buildInstalledBaseSearch('', {}, {}, 'information'),
    };
};
